import qs from 'qs'
import axios from 'axios' // api: https://github.com/axios/axios
import { aesEncrypt } from '../../utils/newAes'
let baseURL
if ( process.env.NODE_ENV === "development" ) {
  // let baseURL = 'https://sd2.glorychains.cn/lawsuitsmaster/'
  baseURL = 'http://192.168.2.115:8888/'
} else {
  baseURL = 'https://sd2.glorychains.cn/lawsuitsmaster/'
}

export let queryRequest = function ( datas = {}, url ) {
  return new Promise( ( ress ) => {
    axios( {
      url: baseURL + url,
      method: "post",
      data: qs.stringify( datas ),
      headers: {
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/x-www-form-urlencoded",
        'accessToken': aesEncrypt( new Date().getTime() ),
      },
    } ).then( ( { data } ) => {
      ress( data );
    } );
  } );
}

export let bodyRequest = function ( datas = {}, url ) {
  return new Promise( ( ress ) => {
    axios( {
      url: baseURL + url,
      method: "post",
      data: datas,
      headers: {
        "Content-Type": "application/json",
        'accessToken': aesEncrypt( new Date().getTime() ),
      },
    } ).then( ( { data } ) => {
      ress( data );
    } );
  } );
}


// export let testRequest=function(datas={},url){
//   return new Promise((ress) => {
//     httpRequest({
//       url: window.SITE_CONFIG["lawsuitApi"]+url,
//       method: "post",
//       data: datas,
//       headers: {
//         // "Content-Type": "multipart/form-data",
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//     }).then(({ data }) => {
//       ress(data);
//     });
//   });
// }



// WEBPACK FOOTER //
// ./src/assets/js/axios.js